import React from "react";
import {
  Award,
  GraduationCap,
  Mail,
  Globe,
  ArrowRight,
} from "lucide-react";
import alejandra from "../img/seminario/comite/alejandra_zuniga.png";
import ana from "../img/seminario/comite/ana_flavio.jpg";
import andrea from "../img/seminario/comite/andre_baez.png";
import jhonatan from "../img/seminario/comite/jhonatan_gomez.jpg";
import luis_aguado from "../img/seminario/comite/luis_aguado.jpg";
import luis_herrero from "../img/seminario/comite/luis_herrero.jpg";
import marcos from "../img/seminario/comite/marcos_valdivia.jpg";
import nora from "../img/seminario/comite/nora_espinal.jpg";
import pedro from "../img/seminario/comite/pedro_costa.jpeg";
import viviana from "../img/seminario/comite/viviana_leonardi.jpg";
import pablo from "../img/seminario/pablo.png";
import ronny from "../img/seminario/comite/ronny.jpg";




// Datos del Comité Científico
const comiteCientifico = [
  {
    nombre: "Alejandra Zúñiga Meneses",
    institucion: "Ministerio de Cultura del Perú",
    pais: "Perú",
    bandera: "🇵🇪",
    enlace: "https://www.linkedin.com/in/ale-zume/?locale=es",
    color: "bg-red-50 text-red-700 border-red-200",
    foto:alejandra,
  },
  {
    nombre: "Ana Flavia Machado",
    institucion: "Universidad Federal de Minas Gerais",
    pais: "Brasil",
    bandera: "🇧🇷",
    enlace: "https://somos.ufmg.br/professor/ana-flavia-machado",
    scholar: "https://scholar.google.com/citations?user=PTet1CUAAAAJ&hl=pt-BR",
    color: "bg-emerald-50 text-emerald-700 border-emerald-200",
      foto:ana,
  },
  {
    nombre: "Andrea Báez Montenegro",
    institucion: "Universidad Austral de Chile",
    pais: "Chile",
    bandera: "🇨🇱",
    enlace: "https://www.economicas.uach.cl/academico/andrez-baez-montenegro/",
    scholar: "https://scholar.google.com/citations?user=9YI9ktQAAAAJ&hl=es",
    color: "bg-blue-50 text-blue-700 border-blue-200",
      foto:andrea,
  },
  {
    nombre: "Luis César Herrero Prieto",
    institucion: "Universidad de Valladolid",
    pais: "España",
    bandera: "🇪🇸",
    enlace: "https://portaldelaciencia.uva.es/investigadores/180511/detalle",
    scholar: "https://scholar.google.com/citations?user=AO-KpioAAAAJ&hl=es",
    color: "bg-amber-50 text-amber-700 border-amber-200",
          foto:luis_herrero,
  },
  {
    nombre: "Luis Fernando Aguado Quintero",
    institucion: "Pontificia Universidad Javeriana",
    pais: "Colombia",
    bandera: "🇨🇴",
    enlace:"https://www.javerianacali.edu.co/profesores/luis-fernando-aguado-quintero",
    scholar: "https://scholar.google.com/citations?user=_DHeLUYAAAAJ&hl=es",
    color: "bg-yellow-50 text-yellow-800 border-yellow-200",
      foto:luis_aguado,
  },
  {
    nombre: "Marcos Valdivia López",
    institucion: "Universidad Nacional Autónoma de México",
    pais: "México",
    bandera: "🇲🇽",
    enlace:"https://www.crim.unam.mx/perfil/valdivia-lopez-marcos/",
    scholar: "https://scholar.google.com/citations?user=kYxApdQAAAAJ&hl=es",
    color: "bg-green-50 text-green-700 border-green-200",
  },
  {
    nombre: "Nora Elena Espinal Monsalve",
    institucion: "Universidad Nacional de Colombia",
    pais: "Colombia",
    bandera: "🇨🇴",
    enlace:
      "https://cienciashumanasyeconomicas.medellin.unal.edu.co/component/content/article/946-nora-elena-espinal-coordinadora-de-la-especializacion-en-economia-de-la-cultura.html?catid=2&Itemid=",
    color: "bg-yellow-50 text-yellow-800 border-yellow-200",
      foto:nora,
  },
  {
    nombre: "Ronny Correa Quezada",
    institucion: "Universidad Técnica Particular de Loja",
    pais: "Ecuador",
    bandera: "🇪🇨",
    enlace: "https://investigacion.utpl.edu.ec/rfcorrea",

    color: "bg-sky-50 text-sky-700 border-sky-200",
    ronny:ronny,
  },
  {
    nombre: "Pablo Cardoso Terán",
    institucion:
      "Facultad Latinoamericana de Ciencias Sociales FLACSO Sede Ecuador",
    pais: "Ecuador",
    enlace: "https://investigacion.utpl.edu.ec/rfcorrea ",
    bandera: "🇪🇨",
    color: "bg-sky-50 text-sky-700 border-sky-200",
    foto:pablo,
  },
  {
    nombre: "Pedro Costa",
    institucion: "Instituto Universitario de Lisboa",
    pais: "Portugal",
    enlace: "https://orcid.org/0000-0002-3073-916X",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=SftyppMAAAAJ&view_op=list_works&sortby=pubdate",
    bandera: "🇵🇹",
    color: "bg-red-50 text-red-700 border-red-200",
      foto:pedro,
  },
  {
    nombre: "Viviana Silvia Leonardi",
    institucion: "Universidad Nacional del Sur",
    pais: "Argentina",
    bandera: "🇦🇷",
    enlace: "http://www.economia.uns.edu.ar/docente/leonardi-viviana-s/",
    scholar: "https://scholar.google.com/citations?user=Rj8R5SMAAAAJ&hl=es",
    color: "bg-cyan-50 text-cyan-700 border-cyan-200",
      foto:viviana,
  },
];

// Datos del Secretario Ejecutivo
const secretarioEjecutivo = {
  nombre: "Jonathan Daniel Gómez Zapata",
  institucion: "Universidad Nacional de Colombia",
  pais: "Colombia",
  bandera: "🇨🇴",
  rol: "Secretario Ejecutivo RIEC",
  correo: "jdgomez@unal.edu.co", // Opcional / ilustrativo
};

export default function Comite() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Cabecera de la Sección */}
        <div className="text-center mb-12">
          <h1 className="text-center sm:text-4xl font-black tracking-tight text-slate-950">
            Comité Científico
          </h1>
        </div>

        {/* Sección de Destacado: Secretario Ejecutivo */}
        <div className="mb-10">
          <div className="relative overflow-hidden rounded-2xl border border-indigo-100 bg-gradient-to-r from-indigo-50/50 to-white p-6 sm:p-8 shadow-sm">
            {/* Elemento de diseño de fondo */}
            <div className="absolute right-0 bottom-0 translate-x-4 translate-y-4 opacity-5 text-indigo-600">
              <Award className="w-40 h-40" />
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 relative z-10">
              <div className="space-y-2">
                <span className="inline-block px-2.5 py-0.5 rounded-md text-[11px] font-bold tracking-wide uppercase bg-indigo-600 text-white">
                  {secretarioEjecutivo.rol}
                </span>
                <h3 className="text-xl font-bold tracking-tight text-slate-900">
                  {secretarioEjecutivo.nombre}
                </h3>
                <div className="flex flex-wrap items-center gap-y-1 gap-x-3 text-sm text-slate-500">
                  <span className="flex items-center gap-1.5 font-medium">
                    <GraduationCap className="w-4 h-4 text-slate-400" />
                    {secretarioEjecutivo.institucion}
                  </span>
                  <span className="hidden sm:inline text-slate-300">•</span>
                  <span className="flex items-center gap-1.5">
                    <span className="text-base">
                      {secretarioEjecutivo.bandera}
                    </span>
                    {secretarioEjecutivo.pais}
                  </span>
                </div>
              </div>

              {/* Botón rápido de acción para el Secretario */}
              {secretarioEjecutivo.correo && (
                <a
                  href={`mailto:${secretarioEjecutivo.correo}`}
                  className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-semibold bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-slate-950 hover:border-slate-300 transition-all shadow-sm"
                >
                  <Mail className="w-3.5 h-3.5 text-slate-400" />
                  <span>siec2026@utpl.edu.ec </span>
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Sección: Miembros del Comité en Formato de Lista */}
        <div>
          <div className="flex items-center justify-between mb-4 pl-1">
            <h2 className="text-xs font-bold uppercase tracking-widest text-slate-400">
              Miembros Académicos
            </h2>
            <span className="text-xs font-semibold text-slate-500 bg-slate-100 px-2.5 py-0.5 rounded-full">
              {comiteCientifico.length} Miembros
            </span>
          </div>

          <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden divide-y divide-slate-100">
            {comiteCientifico.map((miembro, index) => (
              <div
                key={index}
                className="p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-50/70 transition-colors group"
              >
      <div className="flex items-start gap-4">
  {/* Foto del miembro */}
  {miembro.foto ? (
    <img
      src={miembro.foto}
      alt={miembro.nombre}
      className="w-20 h-20 rounded-full object-cover border-2 border-slate-200 shadow-sm shrink-0"
    />
  ) : (
    <div className="w-20 h-20 rounded-full bg-slate-100 border-2 border-slate-200 flex items-center justify-center text-slate-400 font-bold shrink-0">
      {miembro.nombre
        .split(" ")
        .map((p) => p[0])
        .slice(0, 2)
        .join("")}
    </div>
  )}

  <div className="space-y-1">
                    <h4 className="font-bold text-base text-slate-900 group-hover:text-indigo-650 transition-colors">
                      {miembro.nombre}
                    </h4>
                 <div className="space-y-2">
  <p className="text-xs sm:text-sm text-slate-500 flex items-center gap-1.5 leading-relaxed">
    <GraduationCap className="w-3.5 h-3.5 text-slate-400 shrink-0" />
    <span>{miembro.institucion}</span>
  </p>

  <div className="flex flex-wrap gap-2">
    {miembro.enlace && (
      <a
        href={miembro.enlace}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600 hover:border-indigo-300 hover:text-indigo-600 transition"
      >
        <Globe className="w-3 h-3" />
        Perfil
      </a>
    )}

    {miembro.scholar && (
      <a
        href={miembro.scholar}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 hover:bg-emerald-100 transition"
      >
        <Globe className="w-3 h-3" />
        Google Scholar
      </a>
    )}
  </div>
</div>
                  </div>
                </div>

                {/* País / Distintivo */}
                <div className="flex items-center sm:justify-end shrink-0 pl-1 sm:pl-0">
                  <div
                    className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-bold tracking-wide ${miembro.color}`}
                  >
                    <span className="text-base leading-none">
                      {miembro.bandera}
                    </span>
                    <span>{miembro.pais}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
